module.exports = __webpack_public_path__ + "img/v1-member.683e9b21.png";